import { configureBackButton, isTelegramWebAppActive } from '@/utils/telegramWebAppClient'
import logger from '@/utils/logger'

const ROOT_PATHS = new Set(['/', '/pm/le', '/pm/lg'])

export function shouldShowTelegramBackButton(route) {
  if (!isTelegramWebAppActive()) return false
  if (route?.meta?.hideTgBackButton === true) return false
  if (ROOT_PATHS.has(route?.path)) return false
  return true
}

export function resolveTelegramBackHandler(route, router) {
  const target = route?.meta?.tgBackTo
  if (typeof target === 'string' && target) {
    return () => router.push(target)
  }
  return () => router.back()
}

export function syncTelegramBackButton(route, router) {
  if (!route || !router) return false

  try {
    const visible = shouldShowTelegramBackButton(route)
    const onClick = visible ? resolveTelegramBackHandler(route, router) : null
    return configureBackButton({ visible, onClick })
  } catch (error) {
    logger.warn('Failed to sync Telegram back button:', error)
    return false
  }
}
